import gsap from 'gsap';
import { Component } from '@resn/gozer-core/component';
// import { html } from '@resn/gozer-core';
import { autobind } from 'core-decorators';
import { map } from '@resn/gozer-math';

import getStore from 'core/store';
import splitText from 'utils/gsap/split-text';
import cacheUI from '@resn/gozer-dom/cache-ui';

const store = getStore();

// @componentMixin(WithIntersectionObserver)
class TextContentAnimation extends Component {
    props = {
        active: false,
        activeViewport: false,
        animate: false,

        intersecting: false,
    };

    options = {
        dir: 1,
        showOnIntersection: true,
    };

    async onSetup() {
        this.el = this.options.el;
        this.ui = cacheUI(this.el);

        this.setupIntersectionObserver();

        this.elements = [];

        if (this.ui.secondaryIcon) this.setupBlock(this.ui.secondaryIcon);
        if (this.ui.pretitle) this.setupText(this.ui.pretitle);
        if (this.ui.logo) this.setupBlock(this.ui.logo);
        if (this.ui.title) this.setupText(this.ui.title);
        if (this.ui.subtitle) this.setupText(this.ui.subtitle);
        if (this.ui.body) this.setupBlock(this.ui.body);
        if (this.ui.emailBlock) this.setupBlock(this.ui.emailBlock);
        if (this.ui.btnWrap) this.setupBlock(this.ui.btnWrap);
        if (this.ui.btn) this.setupBlock(this.ui.btn);
        // if (this.options.btn) this.elements.push(this.options.btn.el);

        if (this.elements.length) gsap.set(this.elements, { willChange: 'transform', alpha: 0.001, z: 0.001 });
    }

    setupIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '-25%',
            threshold: 0,
        };

        this.observer = new IntersectionObserver(this.onIntersection, options);
        this.observer.observe(this.el);
    }

    setupText(el) {
        const split = new splitText(el, { type: 'lines', linesClass: 'splitText__lines' });

        this.elements.push(...split.lines);
    }

    setupBlock(el) {
        this.elements.push(el);
    }

    @autobind
    onIntersection(entries, observer) {
        const entry = entries.find((entry) => entry.target === this.el);
        if (entry) this.props.intersecting = entry.isIntersecting;
    }

    onIntersecting() {
        if (this.props.active && this.options.showOnIntersection) this.props.animate = true;
    }

    onActive() {
        if (this.props.intersecting) this.props.animate = true;
    }

    offActive() {
        const { scrollDir } = store.state;
        if (scrollDir !== -1) return;
        this.props.animate = false;
    }

    offAnimate({ firstTrigger }) {
        if (firstTrigger) return;

        if (!this.elements.length) return;
        gsap.killTweensOf(this.elements);
        gsap.set(this.elements, { alpha: 0.001 });
    }

    onAnimate() {
        if (!this.elements.length) return;
        const { mobile, scale, scrollDelta } = store.state;

        const dur = mobile ? 1.5 : 1.5;
        const dir = this.options.dir || 1;
        const yDistMobile = map(scrollDelta, 0, 100, 80, 140, true) * scale;
        const yDistDesktop = map(scrollDelta, 0, 200, 80, 200, true) * scale;
        const y = dir * (mobile ? yDistMobile : yDistDesktop);
        const stagger = 0.05;

        gsap.killTweensOf(this.elements);
        gsap.to(this.elements, { alpha: 0.999, duration: 0.8, delay: 0, stagger });
        gsap.fromTo(this.elements, { y }, { y: 0, duration: dur, delay: 0, stagger, ease: 'expo.out' });
    }

    onDestroy() {
        this.observer.unobserve(this.el);
    }
}

export default TextContentAnimation;
